<template>
  <v-row dense class="client-information-form-extension-row" align="start" justify="space-around">
    <v-col cols="auto" class="client-information-form-extension-row-button mt-3">
      <v-btn v-if="showAdd" elevation="0" @click="onAdd" class="d-block mx-auto" fab small>
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-col>
    <v-col cols="auto" class="extensions-row-text-field">
      <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
        <v-text-field
          required
          filled
          rounded
          class="rounded-small"
          dense
          label="Nombre"
          color="blue-grey"
          :value="row.name"
          @input="(newVal) => $emit('data:change', { field: 'name', value: newVal })"
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
    </v-col>
    <v-col cols="auto" class="extensions-row-text-field">
      <ValidationProvider name="extension" rules="required" v-slot="{ errors }">
        <v-text-field
          required
          filled
          rounded
          class="rounded-small"
          dense
          label="Extension"
          color="blue-grey"
          :value="row.extension"
          @input="(newVal) => $emit('data:change', { field: 'extension', value: newVal })"
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
    </v-col>
    <v-col cols="auto" class="extensions-row-text-field">
      <ValidationProvider name="grupo" rules="required" v-slot="{ errors }">
        <v-text-field
          required
          filled
          rounded
          class="rounded-small"
          dense
          label="Grupo"
          color="blue-grey"
          :value="row.group"
          @input="(newVal) => $emit('data:change', { field: 'group', value: newVal })"
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
    </v-col>
    <v-col cols="auto" class="client-information-form-extension-row-button mt-3">
      <v-btn v-if="showDelete" class="d-block mx-auto" @click="onDelete(row.id)" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    showAdd: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
    onAdd: {
      type: Function,
    },
    onDelete: {
      type: Function,
    },
    row: {
      type: Object,
    },
  },

  methods: {
    handleChange() {},
  },
};
</script>

<style>
.extensions-row-text-field {
  width: 26.6666%;
  margin: 3px auto;
}

.client-information-form-extension-row-button {
  width: 10%;
}
</style>
